import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconWhanaungaAwhina = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.584 16.117 5.24 15h8.863c.151 0 .296.059.403.163a.55.55 0 0 1 0 .79.58.58 0 0 1-.403.164h-3.275a.75.75 0 0 0-.521.211.714.714 0 0 0 0 1.021.75.75 0 0 0 .521.212h3.275c.323 0 .64-.075.928-.219.288-.143.537-.352.726-.607q.025-.012.05-.026l3.88-2.192a.583.583 0 0 1 .776.204.58.58 0 0 1 .038.437.6.6 0 0 1-.28.343l-6.1 3.57L5.873 19h-.635l-1.655 1zm10.755 4.4c.143 0 .284-.04.404-.118l6.283-3.688c.45-.277.776-.713.908-1.217a2 2 0 0 0-.195-1.495 2.04 2.04 0 0 0-1.241-.93 2.09 2.09 0 0 0-1.55.197l-2.91 1.644a2 2 0 0 0-.746-.981 2.1 2.1 0 0 0-1.19-.375H5.008a.75.75 0 0 0-.42.129l-1.877 1.26c0 .013-.765.311-.708 1.01v5.203c0 .375.461.844 1.054.844s2.035-1.5 2.635-1.5c.601 0 8.647.017 8.647.017"
      clipRule="evenodd"
    />
    <circle cx={11.75} cy={6} r={3.25} stroke="currentColor" strokeWidth={1.5} />
    <path
      fill="currentColor"
      d="M14.508 8.895a5.4 5.4 0 0 1 1.512 1.124c1.117 1.188 1.703 2.915 1.4 5.085L16.679 15l-.742-.104c.247-1.773-.238-3.031-1.008-3.85-.566-.602-1.32-1.002-2.139-1.184a4 4 0 0 0 1.719-.967M9 8.905a4 4 0 0 0 1.718.96 4.14 4.14 0 0 0-2.058 1.127c-.794.816-1.318 2.091-1.119 3.927L6.797 15l-.746.081c-.24-2.22.389-3.958 1.536-5.136.42-.43.899-.776 1.414-1.04"
    />
  </NcIcon>
);
export { NcIconWhanaungaAwhina };
